'use client';

import { type Dispatch, useReducer } from 'react';

import { type ConfirmationModalState, type ConfirmationModalAction } from '../types';

export const CONFIRMATION_MODAL_DEFAULTS: ConfirmationModalState = null;

export function confirmationModalReducer(
    state: ConfirmationModalState,
    action: ConfirmationModalAction,
): ConfirmationModalState {
    switch (action.type) {
        case 'OPEN_MODAL':
            return { ...action.modal, isOpen: true };
        case 'CLOSE_MODAL':
            return state ? { ...state, isOpen: false } : null;
    }
}

export function useConfirmationModal(): [ConfirmationModalState, Dispatch<ConfirmationModalAction>] {
    return useReducer(confirmationModalReducer, CONFIRMATION_MODAL_DEFAULTS);
}
